import React, { useState } from 'react'
import { InputNumber } from 'primereact/inputnumber'
import { isNonEligibleContributionType, isNonEligibleContributor } from 'modules/Constants'

const MAX_PERCENTAGE = 100

const PercentageEditor = ({ options, validationErrors, episodeDuration, editorCallbacksRef, toastRef, dataKey }) => {
    const rowIndex = options.rowIndex
    const rowData = options.rowData
    const rowKey = rowData[dataKey]
    const [isInvalid, setIsInvalid] = useState(false)
    const [currentContributionType, setCurrentContributionType] = useState(rowData.contributionType)

    // Read-only if contribution type is Actor or Director (regardless of contact type)
    const isReadonly = isNonEligibleContributionType(currentContributionType)

    // Register callbacks keyed by row to support multiple rows editing simultaneously
    if (editorCallbacksRef?.current) {
        if (!editorCallbacksRef.current.percentage) editorCallbacksRef.current.percentage = {}
        if (!editorCallbacksRef.current.setPercentageContributionType) editorCallbacksRef.current.setPercentageContributionType = {}
        editorCallbacksRef.current.percentage[rowKey] = options.editorCallback
        editorCallbacksRef.current.setPercentageContributionType[rowKey] = setCurrentContributionType
    }

    const handleValueChange = (e) => {
        if (isReadonly) return

        const value = e.value

        rowData.percentage = value
        options.editorCallback(value)

        if (value !== null && value > MAX_PERCENTAGE) {
            setIsInvalid(true)
            toastRef?.current?.show({
                severity: 'error',
                summary: 'Validation Error',
                detail: `Percentage cannot be greater than ${MAX_PERCENTAGE}%`,
                life: 3000
            })
            return
        }

        setIsInvalid(false)

        if (episodeDuration > 0 && value !== null && value !== undefined) {
            const calculatedMinutes = (episodeDuration * value) / 100
            const roundedMinutes = Math.round(calculatedMinutes * 100) / 100

            rowData.minutes = roundedMinutes

            if (editorCallbacksRef?.current?.minutes?.[rowKey]) {
                editorCallbacksRef.current.minutes[rowKey](roundedMinutes)
            }
        }
    }

    const hasValidationError = (validationErrors[rowIndex] && validationErrors[rowIndex][options.field]) || isInvalid

    return (
        <InputNumber
            value={options.value}
            onValueChange={handleValueChange}
            className={hasValidationError ? 'p-invalid' : ''}
            useGrouping={false}
            min={0}
            minFractionDigits={2}
            maxFractionDigits={2}
            disabled={isReadonly}
        />
    )
}

export default PercentageEditor
